import React, { useEffect, useState } from 'react';
import { Spinner } from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Input, InputLabel, MenuItem, Select, TextField, TextareaAutosize } from '@mui/material';
import { useParams } from 'react-router-dom';
//import OneDriveTeste from "../OneDriveTeste/OneDriveTeste";
import { insert, update, criaLinkVisualizacaoPdf, getLatestPdfInFolder, notifyByEmail, getProdCoordenadorPfId } from '../../../utils/fc/index.js'
import { notifyError, notifySuccess } from '../../../utils/notify'




const ModalFormElaborado = ( {dataContratual, tecResp, ...props} ) => {

    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState('');
    const [isStatusLoading, setIsStatusLoading] = useState(false);
    const { prod_id, proj_id } = useParams();

    const insertStatusEmElaboracao = async () => {
        setIsStatusLoading(true)
        if (!getProdCoordenadorPfId(props.produto)) {
          return notifyError('Produto sem responsável técnico');
        }
        const inseriu = await insert('prodStatusAlt', {prod_id: props.produto.prod_id, prodStatusTp_id: 2, pf_id: getProdCoordenadorPfId(props.produto), prodStatusAlt_data: moment().format('YYYY-MM-DD'), prodStatusAlt_usuarioCria: props.userOikosId, prodStatusAlt_usuarioMod: props.userOikosId});
        if (inseriu) {
            notifySuccess('Começou a elaboração do produto!');
            setIsStatusLoading(false)
            props.setCount(prevState => prevState + 1);
        }
    };

    const handleClose = () => {
    setOpen(false);
    };


    const handleChange = (event) => {
    setStatus(event.target.value);
    };

    return (
        <>
            {isStatusLoading && (
                <Button
                autoFocus
                margin="dense"
                id="entregaRevInterna"
                name="entrega_rev_interna"
                label="Entrega a Revisao Interna"
                type="submit"
                variant="outlined"
                disabled
                endIcon={<Spinner/>}
                >Aguarde</Button>
            )}
            {!isStatusLoading && (
                <Button variant="" onClick={insertStatusEmElaboracao}>
                    Iniciar Elaboração
                </Button>
            )}
        </>
    )
}

ModalFormElaborado.propTypes = {
    dataContratual: PropTypes.string,
    tecResp: PropTypes.string,
};

export default ModalFormElaborado;
